import api from '../utils/axiosConfig';

export const userService = {
  // Get current user profile
  getProfile: async () => {
    const response = await api.get('/api/users/profile');
    return response.data;
  },

  // Update user profile
  updateProfile: async (profileData) => {
    const response = await api.put('/api/users/profile', profileData);
    return response.data;
  },

  // Add skill
  addSkill: async (skill) => {
    const response = await api.post('/api/users/profile/skills', { skill });
    return response.data;
  },

  // Remove skill
  removeSkill: async (skill) => {
    const response = await api.delete(`/api/users/profile/skills/${encodeURIComponent(skill)}`);
    return response.data;
  },

  // Add software
  addSoftware: async (software) => {
    const response = await api.post('/api/users/profile/software', { software });
    return response.data;
  },

  // Remove software
  removeSoftware: async (software) => {
    const response = await api.delete(`/api/users/profile/software/${encodeURIComponent(software)}`);
    return response.data;
  },

  // Add role keyword
  addRoleKeyword: async (keyword) => {
    const response = await api.post('/api/users/profile/role-keywords', { keyword });
    return response.data;
  },

  // Remove role keyword
  removeRoleKeyword: async (keyword) => {
    const response = await api.delete(`/api/users/profile/role-keywords/${encodeURIComponent(keyword)}`);
    return response.data;
  },

  // Get profile completeness breakdown
  getProfileCompleteness: async () => {
    const response = await api.get('/api/users/profile/completeness');
    return response.data;
  }
}; 